import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  cardBody: {
    padding: theme.spacing(0, 2),
  },
  packageSelect: {
    marginBottom: theme.spacing(3),
  },
  settingsContainer: {
    marginLeft: theme.spacing(1.5),
  },
}));
